export const SHOW_SPINNER = 'SHOW_SPINNER';
export const HIDE_SPINNER = 'HIDE_SPINNER';
export const GET_GITHUB_INITIATE = 'GET_GITHUB_INITIATE';
export const GET_GITHUB_SUCCESS = 'GET_GITHUB_SUCCESS';
export const GET_GITHUB_FAIL = 'GET_GITHUB_FAIL';
export const CHAGE_USER_ID = 'CHAGE_USER_ID';

export const GET_STUDENT_LIST_INITIATE = 'GET_STUDENT_LIST_INITIATE';
export const GET_STUDENT_LIST_SUCCESS = 'GET_STUDENT_LIST_SUCCESS';
export const GET_STUDENT_LIST_FAIL = 'GET_STUDENT_LIST_FAIL';
export const CHAGE_STUD_BIRTHDAY = 'CHAGE_STUD_BIRTHDAY';


export const SET_FLASH_MSG = 'SET_FLASH_MSG';
export const HIDE_FLASH_MSG = 'HIDE_FLASH_MSG';

export const CHANGE_MODAL = 'CHANGE_MODAL';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const SET_MODAL_MSG = 'SET_MODAL_MSG';




export const CHAGE_TEMPLATE_TITLE = 'CHAGE_TEMPLATE_TITLE'
export const CLEAN_TIMELATE_TITLE = 'CLEAN_TIMELATE_TITLE'

export const CHAGE_TEMPLATE_MENU_BUTTON= 'CHAGE_TEMPLATE_MENU_BUTTON'
export const CLEAN_TIMELATE_MENU_BUTTON = 'CLEAN_TIMELATE_MENU_BUTTON'

export const CHAGE_TEMPLATE_BODY = 'CHAGE_TEMPLATE_BODY'
export const CLEAN_TIMELATE_BODY = 'CLEAN_TIMELATE_BODY'

//devise login logout

export const AUTH_START = 'AUTH_START';
export const CHECK_AUTH = 'CHECK_AUTH';
export const START_LOGOUT = 'START_LOGOUT';


export const SET_USER_TOKEN = 'SET_USER_TOKEN';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const CHAGE_TEACHER_PROFILE = 'CHAGE_TEACHER_PROFILE';

export const ADD_MSG = 'ADD_MSG';
export const CREATE_MSG = 'CREATE_MSG';
export const INDEX_MSG = 'INDEX_MSG';
export const DESTROY_MSG = 'DESTROY_MSG';

export const EDIT_APPLICATION_FOR_ADMISSION = 'EDIT_APPLICATION_FOR_ADMISSION';
export const SET_APPLICATION_FOR_ADMISSION = 'SET_APPLICATION_FOR_ADMISSION';
export const UPDATE_APPLICATION_FOR_ADMISSION = 'UPDATE_APPLICATION_FOR_ADMISSION';
export const UPDATE_APPLICATION_FOR_ADMISSION_STUD_IMG = 'UPDATE_APPLICATION_FOR_ADMISSION_STUD_IMG'

export const EDIT_TRANSFER_STUDENT = 'EDIT_TRANSFER_STUDENT';
export const SET_TRANSFER_STUDENT = 'SET_TRANSFER_STUDENT';
export const UPDATE_TRANSFER_STUDENT = 'UPDATE_TRANSFER_STUDENT';

export const EDIT_PARENTAL_STATUS_SURVEY = 'EDIT_PARENTAL_STATUS_SURVEY';
export const SET_PARENTAL_STATUS_SURVEY = 'SET_PARENTAL_STATUS_SURVEY';
export const UPDATE_PARENTAL_STATUS_SURVEY = 'UPDATE_PARENTAL_STATUS_SURVEY';


export const EDIT_HEALTH_QUESTIONNAIRE = 'EDIT_HEALTH_QUESTIONNAIRE';
export const SET_HEALTH_QUESTIONNAIRE = 'SET_HEALTH_QUESTIONNAIRE';
export const UPDATE_HEALTH_QUESTIONNAIRE = 'UPDATE_HEALTH_QUESTIONNAIRE';

export const EDIT_PARENT_PASS = 'EDIT_PARENT_PASS';
export const SET_PARENT_PASS = 'SET_PARENT_PASS';
export const UPDATE_PARENT_PASS = 'UPDATE_PARENT_PASS';
export const UPDATE_PARENT_PASS_IMG = 'UPDATE_PARENT_PASS_IMG';

//入學生以申請書 在校生弟妹
export const INDEX_BROTHERS_MEMBER = 'INDEX_BROTHERS_MEMBER';
export const SET_INDEX_BROTHERS_MEMBER = 'SET_INDEX_BROTHERS_MEMBER';
export const SHOW_BROTHERS_MEMBER = 'SHOW_BROTHERS_MEMBER';
export const SET_SHOW_BROTHERS_MEMBER = 'SET_SHOW_BROTHERS_MEMBER';
export const EDIT_BROTHERS_MEMBER = 'EDIT_BROTHERS_MEMBER';
export const NEW_BROTHERS_MEMBER = 'NEW_BROTHERS_MEMBER';
export const CREATE_BROTHERS_MEMBER = 'CREATE_BROTHERS_MEMBER';
export const DESTROY_BROTHERS_MEMBER = 'DESTROY_BROTHERS_MEMBER';

export const INDEX_FAMILY_MEMBER = 'INDEX_FAMILY_MEMBER';
export const SET_INDEX_FAMILY_MEMBER = 'SET_INDEX_FAMILY_MEMBER';
export const NEW_FAMILY_MEMBER = 'NEW_FAMILY_MEMBER';
export const SET_NEW_FAMILY_MEMBER = 'SET_NEW_FAMILY_MEMBER';
export const CREATE_FAMILY_MEMBER = 'CREATE_FAMILY_MEMBER';
export const DESTROY_FAMILY_MEMBER = 'DESTROY_FAMILY_MEMBER';









// WEBPACK FOOTER //
// ./src/dashboards_redux/constants/actionTypes.jsx